export enum ScheduledJobStatus {
    Pending = 'pending',
    Finished = 'finished',
    Executing = 'executing',
    Error = 'error',
}
